import React from 'react';

const BASE_TAB_OPTIONS = [
	{ value: 'your', label: 'Your' },
	{ value: 'others', label: 'Others' },
];

const TRANSFERRED_TAB_OPTION = { value: 'transferred', label: 'Transferred' };

const YourOthersTabs = ({ value, onChange, includeTransferred = true }) => (
	<div className='mb-4 border-b border-gray-200'>
		<div className='flex items-center gap-6'>
			{(includeTransferred ? [...BASE_TAB_OPTIONS, TRANSFERRED_TAB_OPTION] : BASE_TAB_OPTIONS).map((tab) => {
				const isActiveTab = value === tab.value;
				return (
					<button
						key={tab.value}
						type="button"
						className={`relative whitespace-nowrap pb-3 text-base font-semibold transition-colors ${
							isActiveTab ? 'text-blue-600' : 'text-gray-800'
						}`}
						onClick={() => onChange(tab.value)}
					>
						{tab.label}
						<span
							className={`absolute inset-x-0 -bottom-px h-[3px] rounded-full transition-opacity ${
								isActiveTab ? 'bg-blue-500 opacity-100' : 'opacity-0'
							}`}
						/>
					</button>
				);
			})}
		</div>
	</div>
);

export default YourOthersTabs;
